import React from "react";
import * as ROLES from "../../constants/roles";
import { withAuthorization } from "../Session";
//import { withFirebase } from '../Firebase';

const AdminPage = () => (
  <div className="container">
    <h1>Admin</h1>
    <p>Restricted area! Only users with the admin role are authorized.</p>
  </div>
);
const condition = (authUser) => authUser && !!authUser.roles[ROLES.ADMIN];
export default withAuthorization(condition)(AdminPage);
